<template>
  <div class="mark-down-hj" v-html="renderedMarkdown"></div>
</template>

<script>
  import MarkdownIt from 'markdown-it';

  export default {
    name: 'MD',
    data() {
      return {
        md: new MarkdownIt({
          html: true,
          breaks: true,
          linkify: true,
        }),
      };
    },
    props: {
      contents: { type: String, default: '' },
    },
    computed: {
      renderedMarkdown() {
        // ✨ 수정된 부분: this.contents가 null이나 undefined일 경우 빈 문자열('')을 사용하도록 변경
        return this.md.render(this.contents || '');
      },
    },
  };
</script>

<style>

  .mark-down-hj {
    line-height: 1.7;
  }

  .mark-down-hj ol {
    padding-inline-start: 1rem;
  }

  p .mark-down-hj > ol li {
    margin-top: -1.2em;
  }

  .mark-down-hj > ol {
    list-style-type: lower-latin !important;
  }

</style>
